import React, { useEffect } from 'react';

const Toast = ({ id, type, message, onClose, duration = 5000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(id);
    }, duration);

    return () => clearTimeout(timer);
  }, [id, onClose, duration]);

  const getTypeStyles = () => {
    switch (type) {
      case 'success':
        return {
          bg: 'bg-green-500',
          border: 'border-green-400',
          icon: '✓',
          iconBg: 'bg-green-600'
        };
      case 'error':
        return {
          bg: 'bg-red-500',
          border: 'border-red-400',
          icon: '✕',
          iconBg: 'bg-red-600'
        };
      case 'warning':
        return {
          bg: 'bg-yellow-500',
          border: 'border-yellow-400',
          icon: '⚠',
          iconBg: 'bg-yellow-600'
        };
      case 'info':
        return {
          bg: 'bg-blue-500',
          border: 'border-blue-400',
          icon: 'ℹ',
          iconBg: 'bg-blue-600'
        };
      default:
        return {
          bg: 'bg-gray-500',
          border: 'border-gray-400',
          icon: 'ℹ',
          iconBg: 'bg-gray-600'
        };
    }
  };

  const styles = getTypeStyles();

  return (
    <div className={`
      toast-notification
      ${styles.bg} ${styles.border}
      border-l-4 rounded-r-lg shadow-lg
      flex items-center p-4 mb-3 min-w-80 max-w-md
      text-white font-medium
      transform transition-all duration-300 ease-in-out
      hover:shadow-xl cursor-pointer
    `}
    onClick={() => onClose(id)}
    >
      {/* Icon */}
      <div className={`
        ${styles.iconBg} 
        rounded-full w-8 h-8 flex items-center justify-center
        mr-3 text-sm font-bold flex-shrink-0
      `}>
        {styles.icon}
      </div>
      
      {/* Message */}
      <div className="flex-1 text-sm leading-5">
        {message}
      </div>
      
      {/* Close Button */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClose(id);
        }}
        className="ml-3 text-white/80 hover:text-white transition-colors duration-200 flex-shrink-0"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};

export default Toast;
